// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upgrade_message--content{line-height:1.4;margin-bottom:10px}", "",{"version":3,"sources":["webpack://./resources/client/modules/account/UsersModal.vue"],"names":[],"mappings":"AAIE,0BAEE,eAAA,CADA,kBAFJ","sourcesContent":["\n\n.upgrade_message {\n\n  &--content {\n    margin-bottom: 10px;\n    line-height: 1.4;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
